/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EActionType } from "../types/EActionType.ts";

/**
 * @description 0 = Unknown | 1 = Insert | 2 = Update | 3 = Delete | 4 = Search | 5 = Sync | 6 = Integration | 7 = Enrollment |
 */
export const eActionTypeSchema = z
  .union([
    z.literal(0),
    z.literal(1),
    z.literal(2),
    z.literal(3),
    z.literal(4),
    z.literal(5),
    z.literal(6),
    z.literal(7),
  ])
  .describe(
    "0 = Unknown | 1 = Insert | 2 = Update | 3 = Delete | 4 = Search | 5 = Sync | 6 = Integration | 7 = Enrollment | ",
  ) as unknown as ToZod<EActionType>;
